import { ATTENDANCE_FILTERS } from "constants";

export const DASHBOARD_CARDS = [
  {
    name: "totalDays",
    text: "Total days",
    filterBy: ATTENDANCE_FILTERS.all,
    iconColor: "info",
    iconComponent: "calendar_today",
  },
  {
    name: "weekdaysCount",
    text: "Working Days",
    filterBy: "working_days",
    iconColor: "success",
    iconComponent: "today",
  },
  {
    name: "attendances",
    text: "Checked-In",
    filterBy: ATTENDANCE_FILTERS.checked_in_office,
    iconColor: "primary",
    iconComponent: "corporate_fare",
  },
  {
    name: "wfhCount",
    text: "WFH",
    filterBy: ATTENDANCE_FILTERS.checked_in_wfh,
    iconColor: "warning",
    iconComponent: "home",
  },
  {
    name: "mixedDays",
    text: "Hybrid Days",
    filterBy: "mixed_days",
    iconColor: "secondary",
    iconComponent: "swap_horiz",
  },
  {
    name: "leavesCount",
    text: "Leaves",
    filterBy: ATTENDANCE_FILTERS.absent,
    iconColor: "dark",
    iconComponent: "notifications_off",
  },
];

export const THEME_COLORS = {
  primary: "#18C1E8",
  secondary: "#9825B9",
  secondary_light: "#DADADA40",
  black: "#000000",
  white: "#ffffff",
};

export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    fontSize: 12,
    minHeight: "15px",
    height: "35px",
    textAlign: "left",
    borderRadius: "0.5rem",
    border: "none",
    boxShadow: "none",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: THEME_COLORS.black,
  }),
  menu: (base) => ({ ...base, zIndex: 9 }),
  option: (provided, state) => {
    const selectedOptionColor = THEME_COLORS.white;
    const selectedOptionBackgroundColor = THEME_COLORS.primary;
    const selectedOptionColorLight = THEME_COLORS.black;
    const selectedOptionBackgroundColorLight = THEME_COLORS.secondary_light;
    return {
      ...provided,
      height: 35,
      fontSize: 12,
      color: state.isSelected && selectedOptionColor,
      backgroundColor: state.isSelected && selectedOptionBackgroundColor,
      "&:hover": {
        color: state.isSelected ? selectedOptionColor : selectedOptionColorLight,
        backgroundColor: state.isSelected
          ? selectedOptionBackgroundColor
          : selectedOptionBackgroundColorLight,
      },
      "&:focus": {
        color: state.isSelected ? selectedOptionColor : selectedOptionColorLight,
        backgroundColor: state.isSelected
          ? selectedOptionBackgroundColor
          : selectedOptionBackgroundColorLight,
      },
      "&:active": {
        color: state.isSelected ? selectedOptionColor : selectedOptionColorLight,
        backgroundColor: state.isSelected
          ? selectedOptionBackgroundColor
          : selectedOptionBackgroundColorLight,
      },
    };
  },
};
